import React from "react";


import { connect } from "react-redux";
class HeadSearch extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }

  
    

    render(){
    console.log('Inside render');
    return(
       
        <div class="headsrch">
        <div class="input-group">
            <input type="text" class="form-control" placeholder="Search txn..." 
            aria-describedby="srchbtn" onChange={this.searchButtonSelect}/>
            <button class="btn" type="button" id="srchbtn">search</button>
        </div>							
        </div>
        
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(HeadSearch);
